<template>
  <div id="app">
    <div class="container">
      <top-footer></top-footer>
      <div class="about-project-wrapper">
        <div class="about-project">
          <div class="header-container">
            <p class="header-text">Про проєкт</p>
          </div>
          <div class="content-container">
            <p class="normal-text">
              Непрозорі угоди, укладені розпорядниками місцевих бюджетних коштів, рідко <a
                href="https://www.checkregion-ua.info/fontan-koruptsiinykh-idei-abo-kudy-u-vasylivtsi-zlyly-derzhavni-koshty-2/"
                class="h-link"
              >опиняються в центрі уваги</a>, на відміну від корупційних закупівель великих держпідприємств.
            </p>
            <p class="normal-text">
              Мета цього проєкту – проаналізувати закупівлі майже 10 тисяч розпорядників місцевих бюджетів та виявити «локальних монополістів», тобто компанії та підприємців, що отримують найбільшу кількість замовлень і коштів під час проведення публічних закупівель. Домінування одних і тих самих постачальників у різних закупівельних сферах може свідчити про корупцію в органах місцевої влади.
              Візуалізацію побудовано на основі відкритих даних системи <a
                href="https://prozorro-api-docs.readthedocs.io/uk/master/"
                class="h-link"
              >Prozorro</a> та даних <a
                href="https://openbudget.gov.ua/"
                class="h-link"
              >Державного веб-порталу Open Budget</a>.
            </p>
          </div>
        </div>
      </div>
      <div class="how-to-section is-closed">
        <div
          class="how-to-border"
          v-on:click="switchHowTo"
        >
          <div class="how-to-bar">
            <div class="pointer-icon">
              <!-- &#9757; -->
              <img src="./assets/images/pointer-icon.png">
            </div>
            <p class="how-to-title">
              Як користуватись візуалізацією?
            </p>
          </div>
          <div class="how-to-description">
            <ol>
              <li>Знайдіть потрібне місто або громаду, користуючись формою пошуку внизу.</li>
              <li>Оберіть рік, за який потрібно проаналізувати закупівлі.</li>
              <li>Оберіть спосіб відображення закупівель місцевого бюджету – за сумою витрачених грошей або за кількістю підписаних угод в системі Prozorro. </li>
              <li>Отримайте діаграму на лівій панелі, що покаже місцевий бюджет у вигляді розподілу потоків до основних закупівельних категорій.</li>
              <li>Обравши певний потік на діаграмі, ви зможете побачити топ підрядників місцевої влади у найвагоміших сферах бюджетних витрат (будівельні роботи, послуги з вивезення сміття, закупівля медикаментів, палива, харчових продуктів тощо).</li>
              <li>Ранжуйте підрядників за кількістю підписаних угод або сумою отриманих з бюджету коштів та порівнюйте, наскільки конкурентною є кожна із закупівельних галузей. Докладнішу інформацію про кожного з підрядників можна отримати, клікнувши на його рядок у таблиці та перейшовши на сервіс <a
                  href="https://ring.org.ua"
                  class="h-link"
                >RING</a>.
              </li>
              <li>Остання колонка у таблиці показує, чи фігурує компанія-підрядник у <a
                  href="https://amcu.gov.ua/napryami/oskarzhennya-publichnih-zakupivel/zvedeni-vidomosti-shchodo-spotvorennya-rezultativ-torgiv?v=5dd65bb5563c7"
                  class="h-link"
                >зведених відомостях Антимонопольного комітету України</a> щодо спотворення результатів торгів станом на сьогодні. </li>
            </ol>
          </div>
        </div>
      </div>
      <!-- <div class="section-block">
        <p class="block-header">
          Як користуватись візуалізацією
        </p>
        <p class="block-text">
          <ol>
            <li>Знайдіть потрібне місто або громаду, користуючись формою пошуку внизу.</li>
            <li>Оберіть рік, за який потрібно проаналізувати закупівлі.</li>
            <li>Оберіть спосіб відображення закупівель місцевого бюджету – за сумою витрачених грошей або за кількістю підписаних угод в системі Prozorro. </li>
            <li>Отримайте діаграму на лівій панелі, що відобразить місцевий бюджет у вигляді розподілу потоків до основних закупівельних категорій.</li>
            <li>Обравши певний потік на діаграмі, ви зможете побачити топ підрядників місцевої влади у найвагоміших сферах бюджетних витрат (будівельні роботи, послуги із вивезення сміття, закупівля медикаментів, палива, продуктів харчування тощо).</li>
            <li>Ранжуйте підрядників за кількістю підписаних угод або сумою отриманих з бюджету коштів та порівнюйте наскільки конкурентною є кожна із закупівельних галузей. Більш детальну інформацію по кожному із підрядників можна отримати, клікнувши на його код ЄДРПОУ та перейшовши на сервіс <a href="https://opendatabot.ua/" class="h-link">Opendatabot</a>.
            Остання колонка у таблиці показує чи фігурувала колись компанія-підрядник у <a href="https://amcu.gov.ua/napryami/oskarzhennya-publichnih-zakupivel/zvedeni-vidomosti-shchodo-spotvorennya-rezultativ-torgiv?v=5dd65bb5563c7" class="h-link">зведених відомостях Антимонопольного комітету України щодо спотворення результатів торгів.</a> </li>
          </ol>
        </p>
      </div> -->
      <top-filters
        :jsonContractors="jsonContractors"
        :budgetName="budgetName"
        @sendBudgetName="getBudgetName"
        @sendFiltersProps="getFiltersProps"
      ></top-filters>
      <div class="main-grid">
        <div class="chart-area">
          <div class="chart-title">
            <span class="dynamic-text">{{ budgetName }}</span> - розподіл
            категорій
          </div>
          <div class="chart-body">
            <sankey-chart
              :budgetChoice="budgetName"
              :quantitySelected="quantitySelected"
              :yearSelected="yearSelected"
              @sendCategory="getCategory"
            ></sankey-chart>
          </div>
        </div>
        <div class="table-area">
          <div class="table-title">
            Топ підрядників в категорії:
            <span class="dynamic-text">{{ categoryChoice }}</span>
          </div>
          <div class="table-body">
            <table-view
              :currentCategoryData="currentCategoryData"
              :quantitySelected="quantitySelected"
            ></table-view>
          </div>
        </div>
      </div>
      <div class="section-block small-margin">
        <p class="block-header">
          Дані та методологія
        </p>
        <p class="block-text">
          Основу цього проєкту становлять відкриті дані закупівель системи <a
            href="https://prozorro-api-docs.readthedocs.io/uk/master/"
            class="h-link"
          >Prozorro</a> за період 2019–2020 років. Ці дані охоплюють бюджети 891 громади, 9897 юридичних осіб-закупівельників, 115 715 підрядників та понад 1 мільйон підписаних угод між ними. Приналежність організацій-закупівельників до того чи іншого бюджету було встановлено, використовуючи дані порталу <a
            href="https://openbudget.gov.ua/"
            class="h-link"
          >Open Budget</a>.
        </p>
      </div>
      <div class="stats-blocks-wrapper">
        <div class="stats-blocks">
          <div class="stats-cell">
            <div class="stats-number">891 </div>
            <div class="stats-label"> громад </div>
          </div>
          <div class="stats-cell">
            <div class="stats-number">~10 <span>тис.</span></div>
            <div class="stats-label"> юридичних осіб-закупівельників </div>
          </div>
          <div class="stats-cell">
            <div class="stats-number">115+ <span>тис.</span></div>
            <div class="stats-label"> підрядників </div>
          </div>
          <div class="stats-cell">
            <div class="stats-number">1 <span>млн.</span></div>
            <div class="stats-label"> підписаних угод </div>
          </div>
        </div>
      </div>
      <div class="section-block">
        <p class="block-text">
          Аналіз структури закупівель місцевих бюджетів проведено у розрізі материнських закупівельних категорій (розділів) <a
            href="https://ips.ligazakon.net/document/ME151318"
            class="h-link"
          >Єдиного закупівельного словника ДК 021:2015</a>. На початку аналізу з бази закупівель було вилучено записи, що стосуються закупівлі та розподілу води, тепла та електроенергії, оскільки постачання цих товарів та послуг в Україні має характер природної монополії. Візуалізація місцевих бюджетів у вигляді потокової діаграми відображає лише найбільш значущі категорії закупівель. Значущість кожної категорії оцінювалася за кількістю підписаних угод та загальною вартістю закупівель. На діаграмі показано лише ті категорії, сумарна вартість та кількість контрактів у яких становить не менш ніж 1% від усієї вартості та кількості контрактів у бюджеті. Розрізнені та дрібні закупівлі по решті категорій об’єднано у вигляді великої групи «Інше».
        </p>
      </div>
      <footer class="grid">
        <div class="footer-content content">
          <div class="created-by-texty">
            <p>Створено Текстами</p>
            <img src="./assets/images/white_logo.texty.svg" />
          </div>
          <div class="socio-wrapper">
            <p>Поширити:</p>
            <div class="socio-icons-box">
              <a
                href="https://www.facebook.com/sharer/sharer.php?u=https://texty.org.ua/d/2021/top10_contractors/"
                class="icon-wrapper"
              >
                <img
                  src="./assets/images/share-icon-border.png"
                  class="icon-box"
                />
                <img
                  src="./assets/images/fb.png"
                  class="icon-box"
                  id="fb"
                /></a><a
                href="https://twitter.com/intent/tweet?text=https://texty.org.ua/d/2021/top10_contractors/"
                class="icon-wrapper"
              >
                <img
                  src="./assets/images/share-icon-border.png"
                  class="icon-box"
                />
                <img
                  src="./assets/images/twitter.png"
                  class="icon-box"
                  id="tw"
                /></a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import TopFooter from "./components/TopFooter.vue";
import SankeyChart from "./components/SankeyChart.vue";
import TopFilters from "./components/TopFilters";
import TableView from "./components/Grid";
import getBudgetByName from "./getBudgetByName.js";

export default {
  name: "App",
  components: {
    TopFooter,
    SankeyChart,
    TopFilters,
    TableView,
  },
  emits: ["sendBudgetName"],
  data() {
    return {
      jsonContractors: [],
      budgetName: "Авангардівська селищна ОТГ",
      categoryName: undefined,
      // further resolve an issue with duplicating this data in two components
      quantitySelected: "суми",
      yearSelected: 2020,
      currentBudgetData: [],
    };
  },
  methods: {
    switchHowTo(event) {
      event.currentTarget.parentNode.classList.toggle("is-closed");
      event.currentTarget.parentNode.classList.toggle("is-open");
    },
    getBudgetName(name) {
      this.budgetName = name;
    },
    getCategory(category) {
      this.categoryName = category;
    },
    getFiltersProps(filterProps) {
      this.quantitySelected = filterProps["quantity"];
      this.yearSelected = filterProps["year"];
    },
    async getCurrentBudget(name) {
      return await getBudgetByName(name);
    },
  },
  watch: {
    async budgetName() {
      this.currentBudgetData = await this.getCurrentBudget(this.budgetName);

      this.categoryName = undefined;
      // console.log(this.currentBudgetData);
    },
  },

  async mounted() {
    // this.jsonContractors = require("@/assets/data/sample_contractors_data.json");
    this.jsonContractors = require("@/assets/data/budget_names.json");

    this.currentBudgetData = await getBudgetByName(this.budgetName);
  },
  computed: {
    // currentBudgetData() {
    //   return data;
    //   // return this.jsonContractors.filter(
    //   //   (row) => row["budgetName"] === this.budgetName
    //   // );
    // },
    defaultCategory() {
      if (this.currentBudgetData.length) {
        // console.log([...this.currentBudgetData]);
        return [...this.currentBudgetData].sort((a, b) => {
          return b["tot_value"] - a["tot_value"];
        })[0]["cat_name"];
        // return this.currentBudgetData[0]["cat_name"];
      } else {
        return "";
      }
    },
    categoryChoice() {
      return this.categoryName ? this.categoryName : this.defaultCategory;
    },
    currentCategoryData() {
      return this.currentBudgetData
        .filter(
          (row) =>
            row["cat_name"] === this.categoryChoice &&
            parseInt(row["year"]) === this.yearSelected
        )
        .sort((a, b) => {
          let sortCol;
          if (this.quantitySelected == "суми") {
            sortCol = "tot_value";
          } else {
            sortCol = "tot_contracts";
          }

          return b[sortCol] - a[sortCol];
        });
    },
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: e-UkraineLight;
  src: url(./assets/fonts/e-Ukraine-Light.woff);
}

@font-face {
  font-family: e-UkraineRegular;
  src: url(./assets/fonts/e-Ukraine-Regular.woff);
}

@font-face {
  font-family: e-UkraineHead;
  src: url(./assets/fonts/e-UkraineHead-NAME.otf);
}

* {
  margin: 0;
  padding: 0;
}

.container {
  font-family: e-UkraineLight;
  .header-wrapper,
  .logo-footer,
  .how-to-section,
  .section-block,
  .stats-blocks,
  .main-grid,
  .header-filters,
  .about-project {
    max-width: 1680px;
    @media (min-width: 1680px) {
      width: 1408px;
    }
    @media (min-width: 1280px) and (max-width: 1679px) {
      width: 1120px;
    }
    @media (min-width: 992px) and (max-width: 1279px) {
      width: 864px;
    }
    @media (max-width: 991px) and (min-width: 480px) {
      width: 95%;
    }
    @media (max-width: 479px) {
      // width: 100%;
      width: 90%;
    }
  }
  .section-block {
    margin: 0px auto 64px auto;
    &.small-margin {
      margin: 0px auto 32px auto;
    }
  }
  @media (max-width: 768px) {
    .section-block {
      .block-text {
        max-width: 100%;
      }
    }
  }
  p.normal-text {
    line-height: 1.5em;
    margin-bottom: 1em;
  }
  p.block-header {
    font-size: 1.7em;
    margin-bottom: 1em;
    display: block;
  }
  p.block-text {
    line-height: 1.5em;
    margin-bottom: 1em;
    max-width: 70%;
    &:last-child {
      margin-bottom: 0;
    }
  }
  a.h-link {
    text-decoration: none;
    border-bottom: 1px solid black;
    color: black;
    &:hover {
      color: #616365;
      border-color: #616365;
    }
  }
  input,
  select {
    font-family: e-UkraineLight;
    font-size: 24px;
  }
  .about-project {
    margin: 120px auto 2.5em;
    padding-bottom: 2.5em;
    display: grid;
    grid-template-areas: "project-header project-text" ". next-button";
    grid-template-columns: 0.4fr 0.6fr;
    column-gap: 30px;
    .header-container {
      display: flex;
      justify-content: center;
      grid-area: project-header;
      .header-text {
        font-family: e-UkraineRegular;
        font-size: 2.9em;
        height: fit-content;
      }
    }
    .header-text-small {
      font-family: e-UkraineRegular;
      font-size: 2em;
      margin: 1em 0 0.7em 0;
    }
    .content-container {
      grid-area: project-text;
    }
    .read-next-button {
      grid-area: next-button;
      display: inline-block;
      width: fit-content;
      align-items: center;
      color: white;
      background-color: black;
      padding: 16px 32px;
      border-radius: 40px;
      height: 30px;
      border: 2px solid black;
      cursor: pointer;
      text-decoration: none;
      height: fit-content;
      // @include button-on-hover;
    }
  }
  @media (max-width: 768px) {
    .about-project {
      grid-template-columns: 0.5fr 0.5fr;
    }
  }
  @media (max-width: 480px) {
    .about-project {
      display: block;
      max-width: none;
      width: 90%;
      .header-container {
        display: block;
        .header-text {
          margin-bottom: 1em;
        }
      }
    }
  }
  .how-to-section {
    margin: 0px auto 36px auto;
    display: flex;
    flex-direction: column;
    position: relative;
    // width: 67%;
    transition: background-color 0.5s ease-in-out;
    .how-to-border {
      width: 45%;
      border: double 2px transparent;
      cursor: pointer;
      background-image: linear-gradient(white, white),
        radial-gradient(
          circle at top left,
          #c3aab2 0.66%,
          #99eecc 57.2%,
          #80c0c8 75.87%,
          #4b8bfa 98.72%
        );
      background-origin: border-box;
      background-clip: padding-box, border-box;
      .pointer-icon {
        font-size: 28px;
      }
    }
    .how-to-bar {
      display: flex;
      flex-direction: row;
      align-items: center;
      position: relative;
      .pointer-icon {
        padding-left: 16px;
        display: inline-block;
        margin-right: 8px;
        img {
          height: 28px;
          width: 28px;
          // margin-bottom: -2px;
        }
      }
      &:before,
      &:after {
        position: absolute;
        top: 22px;
        right: 16px;
        width: 2px;
        height: 20px;
        content: "";
        background-color: #000;
        transition: 0.3s ease-in-out;
      }
      &:after {
        transform: rotate(90deg);
      }
      p.how-to-title {
        font-size: 1.2em;
        padding: 20px 0;
        transition: 0.5s;
      }
    }
    .how-to-description {
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.2s ease-out;
      padding: 0 32px 0px 16px;
      ol {
        padding: 16px 0 0 16px;
        line-height: 1.5em;
        font-size: 13px;
        width: 95%;
      }
      li {
        margin-bottom: 8px;
      }
    }
    &.is-open {
      span {
        background: transparent;
      }
      .how-to-description {
        max-height: 1000px;
        padding: 0 16px 16px 16px;
      }
      .how-to-bar {
        &:before {
          transform: rotate(90deg);
        }
      }
    }
    &.is-closed {
      &:hover {
        background-color: inherit;
        color: black;
        p.how-to-title {
          transform: none;
        }
        span {
          background: transparent;
        }
        &:before {
          background-color: black;
          transform: none;
        }
        &:after {
          background-color: black;
          transform: rotate(90deg);
        }
      }
    }
  }
  @media (max-width: 768px) {
    .how-to-section {
      .how-to-border {
        width: 70%;
      }
    }
  }
  @media (max-width: 480px) {
    .how-to-section {
      .how-to-border {
        width: 100%;
        .how-to-title {
          width: 75%;
        }
        .how-to-description {
          // width: 95%;
          padding: 0 8px 0px 8px;
        }
      }
      &.is-open {
        .how-to-description {
          padding: 0 8px 16px 8px;
        }
      }
    }
  }
  .header-filters {
    font-family: e-UkraineLight;
    font-size: 24px;
    margin: 0px auto 48px auto;
  }
  .main-grid {
    font-family: e-UkraineRegular;
    font-size: 14px;
    display: grid;
    grid-template-columns: 30% 65%;
    margin: 0px auto 64px auto;
    grid-gap: 5%;
    .chart-title,
    .table-title {
      // padding-bottom: 16px;
      height: 48px;
      .dynamic-text {
        color: #6e7dbd;
      }
    }
    .chart-title {
      padding-right: 40px;
    }
  }
  @media (max-width: 768px) {
    .main-grid {
      display: block;
      // grid-template-columns: auto;
      // grid-template-rows: auto 550px;
      .chart-area {
        padding-right: 128px;
        box-sizing: border-box;
      }
    }
  }
  @media (max-width: 480px) {
    .main-grid {
      .chart-area {
        padding-right: 0;
      }
    }
  }
  .stats-blocks-wrapper {
    // background: #e5ebe6;
    // padding: 40px 0;
    // padding: 64px 0;
    margin-bottom: 32px;
    .stats-blocks {
      margin: 0px auto 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: center;
      // flex-wrap: wrap;
      .stats-cell {
        // flex-basis: 19%;
        // flex-basis: 208px;
        // background-color: white;
        background-color: #dbeaeb;
        padding: 1em 2% 1em 2%;
        margin: 0 2% 2% 0;
        // &.last-row {
        //     margin: 0 2% 0 0;
        // }
        .stats-number {
          // font-size: 1.3em;
          font-size: 3.75em;
          margin-bottom: 24px;
          span {
            // margin-left: 2%;
            // font-size: 6vw;
            font-size: 0.9em;
          }
        }
        .stats-label {
          font-size: 1em;
        }
      }
    }
    @media (max-width: 768px) {
      .stats-blocks {
        flex-wrap: wrap;
        justify-content: flex-start;
        .stats-cell {
          flex-basis: 44%;
          // margin: 0 0 2% 0;
          &.last-row {
            margin: 0 0 2% 0;
          }
        }
      }
    }
    @media (max-width: 480px) {
      .stats-blocks {
        flex-direction: column;
        .stats-cell {
          margin: 0 0 2% 0;
          &.last-row {
            margin: 0 0 2% 0;
          }
        }
      }
    }
  }
  footer.grid {
    margin-top: 64px;
    display: grid;
    grid-template-columns: [start] 1fr [content-start text-start] 5fr [middle] 5fr [content-end] 1fr [end];
    font-style: normal;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.02em;
    background-color: black;
    .footer-content {
      padding: 3em 0;
      display: flex;
      justify-content: space-between;
      grid-column: content-start/content-end;
      .created-by-texty,
      .socio-wrapper {
        p {
          margin: 10px 0;
          color: #ece9e5;
        }
        img {
          width: 180px;
        }
      }
      .socio-icons-box {
        display: flex;
        .icon-wrapper {
          box-sizing: border-box;
          margin-right: 12px;
          position: relative;
          width: 36px;
          height: 36px;
          text-decoration: none;
          .icon-box {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            width: 36px;
            height: 36px;
            box-sizing: border-box;
          }
          #fb {
            position: absolute;
            left: 36.11%;
            right: 36.11%;
            top: 25%;
            bottom: 22.22%;
            width: 10px;
            height: 19px;
            box-sizing: border-box;
          }
          #tw {
            position: absolute;
            left: 25%;
            right: 25%;
            top: 27.78%;
            bottom: 30.56%;
            width: 18px;
            height: 15px;
            box-sizing: border-box;
          }
        }
      }
    }
  }
  @media (max-width: 320px) {
    footer.grid {
      font-size: 14px;
      .footer-content {
        .created-by-texty {
          img {
            width: 148px;
          }
        }
        .socio-icons-box {
          .icon-wrapper {
            // width: 24px;
            // height: 24px;
          }
        }
      }
    }
  }
}
</style>
